const TransitionTypes = {
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical',
  FADE: 'fade'
};
export default TransitionTypes;